import React, { FC, memo } from 'react';

import { ContainerProps, Svg } from '@lglp/components';

const MenuIcon: FC<ContainerProps> = ({ className, ...rest }) => (
  <Svg className={['menu-icon', className]} viewBox="0 0 30 13" {...rest}>
    <path d="M1 0 L30 0 M1 7 L30 7 M1 14 L30 14" />
  </Svg>
);

export default memo(MenuIcon);
